module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app bg-gray",
    attrs: {
      "id": "myReport-myReport"
    }
  }, [_c('hospital-select', {
    on: {
      "selected": function($event) {
        return _vm.selectHospital()
      }
    }
  }), _vm._v(" "), _c('voucher-select', {
    attrs: {
      "list": _vm.voucherList
    },
    on: {
      "selected": _vm.selectVoucher
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "report-container thick",
    staticStyle: {
      "margin-top": "1px"
    }
  }, _vm._l((_vm.areas), function(item) {
    return _c('div', {
      key: item.itemId,
      staticClass: "report-item",
      attrs: {
        "id": 'myreport-item-' + item.itemId
      },
      on: {
        "click": function($event) {
          return _vm.onSelectedArea(item)
        }
      }
    }, [_c('span', {
      staticClass: "report-label",
      class: {
        active: _vm.selectedArea.itemId == item.itemId
      }
    }, [_vm._v(_vm._s(item.itemName))])])
  }), 0), _vm._v(" "), _c('scroll', {
    staticStyle: {
      "top": "5.4rem"
    },
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('no-record', {
    attrs: {
      "condition": _vm.reprotList,
      "tips": "抱歉，没有报告记录",
      "id": "myreport-norecord"
    }
  }), _vm._v(" "), _vm._l((_vm.reprotList), function(report, index) {
    return _c('section', {
      key: index,
      staticClass: "thick",
      attrs: {
        "id": 'myreport-list-' + index
      },
      on: {
        "click": function($event) {
          return _vm.goReportDetail(report)
        }
      }
    }, [_c('div', {
      staticClass: "panel ellipsis"
    }, [_c('span', [_vm._v(_vm._s(report.examItem ? report.examItem : report.labItem))])]), _vm._v(" "), _c('div', {
      staticClass: "content arr-row f-minor"
    }, [_c('span', [_vm._v(_vm._s(report.deptName) + "/" + _vm._s(report.doctName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("完成时间")]), _vm._v("    "), _c('span', [_vm._v(_vm._s(report.examTime ? report.examTime : report.labTime))]), _c('br')]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.printEnable),
        expression: "printEnable"
      }],
      staticClass: "bottom arr-row",
      attrs: {
        "id": "myreport-show-qrcode"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showHelp(report)
        }
      }
    }, [_c('span', {
      staticClass: "f-strong"
    }, [_vm._v("打印报告单")]), _vm._v(" "), _c('div', {
      staticClass: "right-txm"
    })])])
  }), _vm._v(" "), _c('popup', {
    staticClass: "mask",
    attrs: {
      "id": "myreport-qrcode"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "show-bar-code"
  }, [_c('div', {
    staticClass: "report-detail"
  }, [_c('div', {
    staticClass: "report-detail-qrcode"
  }, [_c('div', [_c('p', [_vm._v("打印报告二维码")]), _vm._v(" "), _c('section', {
    staticClass: "thick",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('qrcode', {
    staticClass: "qrcode",
    attrs: {
      "size": 171,
      "cls": _vm.qrCls,
      "value": _vm.qrText
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "help"
  }, [_c('div', {
    staticClass: "introduce-info"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "f-minor"
  }, [_vm._v("\n                  第一步，请您前往医院带GWI标识自助设备区域。\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "f-minor"
  }, [_vm._v("\n                  第二步，请在自助机上的扫描区域扫描该二维码，就可以在自助机上打印报告。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "zhj-img"
  })])])])])])], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-tips"
  }, [_c('p', [_vm._v("\n      温馨提示：1.特殊项目（如HIV、梅毒、微生物项目）不能查询；2.查询结果不作为任何医学凭据，请以医院打印报告单为准。\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17ee01c9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/myreport/MyReport.vue
// module id = 792
// module chunks = 0